module.exports = __webpack_public_path__ + "img/nav-Performance-Gray.e9dac28a.png";